import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Divider, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
import Global from '../../../customlib/Global';
class FollowUpRutinMobile extends Component {
    state = {

     } 

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Follow Up Harian"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}>
                        <TextField
                            onChange={this.props.handleKeyword}
                            label="sales / customer / nomor wa / kategori"
                            type="text"
                            className="form-control"
                            id="namacustomer"
                            variant="outlined"
                            onKeyDown={this.props.onKeyDownHandler}
                            onBlur={() => {
                                
                            }}
                            size='small'
                            fullWidth
                        />
                    </Filter>
                    {
                    this.props.state.listMycustomer?.map((lead, index) => {
                        console.log("FUHARIAN", lead);
                        // return (<></>);
                        return (
                            <Accordion key={`key-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={8}>
                                            <Typography component="span">{lead.fromName}</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"left"} sx={{pr: "5px"}}>
                                            {Array.isArray(lead.fuData) ? lead.fuData.length : 0} FU
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography component="span">{lead.from}</Typography>
                                        </Grid>
                                        <Grid item xs={4} textAlign={"left"} sx={{pr: "5px"}}>
                                            {Global.formatDateTimeToStrDate(lead.created_at)}
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Paper elevation={0} sx={{mb: "0px", padding: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Permasalahan</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {!lead.isEditing && lead.alasanUmum}
                                                {lead.isEditing && (
                                                    <FormControl fullWidth variant="outlined" style={{width: '100%'}} size='small'>
                                                        <InputLabel id="demo-simple-select-outlined-label">Permasalahan</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="permasalahan"
                                                            value={lead.permasalahan === undefined | lead.permasalahan === null ? "" : lead.permasalahan}
                                                            onChange={(event) => this.props.handlePermasalahanChange(event, lead)}
                                                            label="Permasalahan"
                                                        >
                                                            {
                                                            Global.getListPermasalahan().map(
                                                                (permasalahan, index) => {
                                                                return (<MenuItem textAlign={"left"} key={"permasalahan" + index + lead._id} value={permasalahan.permasalahan}>{permasalahan.permasalahan}</MenuItem>);
                                                                } 
                                                            )
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Alasan Umum</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {!lead.isEditing && lead.alasanUmum}
                                                {
                                                    lead.isEditing && (
                                                        <Box>
                                                            <FormControl variant="outlined" style={{width: '100%'}} size='small'>
                                                                <InputLabel id="demo-simple-select-outlined-label">Alasan Umum</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-outlined-label"
                                                                    id="alasanUmum"
                                                                    value={lead.alasanUmum === undefined | lead.alasanUmum === null ? "" : lead.alasanUmum}
                                                                    onChange={(event) => this.props.handleAlasanUmumChange(event, lead)}
                                                                    label="Alasan Umum"
                                                                >
                                                                    {
                                                                    Global.getListAlasanUmum(lead.permasalahan).map(
                                                                        (alasanUmum, index) => {
                                                                        return (<MenuItem key={"alasanUmum" + index + lead._id} value={alasanUmum.name}>{alasanUmum.name}</MenuItem>);
                                                                        } 
                                                                    )
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                            {
                                                                lead.lastFuResultTmp === "Order" ? 
                                                                    (<TextField id="outlined-basic" label="Total Order" variant="outlined" style={{marginTop: 10}} value={lead.totalOrder} onChange={(event) => {this.props.handleTotalOrderChange(event, lead)}} />) : 
                                                                    (<></>)
                                                            }
                                                        </Box>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>Alasan Rinci</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {!lead.isEditing && lead.alasanRinci}
                                                {
                                                    lead.isEditing && (
                                                        <Box>
                                                            <FormControl variant="outlined" style={{width: '100%'}} size='small'>
                                                                <InputLabel id="demo-simple-select-outlined-label">Alasan Rinci</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-outlined-label"
                                                                    id="alasanRInci"
                                                                    value={lead.alasanRinci === undefined | lead.alasanRinci === null ? "" : lead.alasanRinci}
                                                                    onChange={(event) => this.props.handleAlasanRinciChange(event, lead)}
                                                                    label="Alasan Rinci"
                                                                >
                                                                    {
                                                                    Global.getListAlasanRinci(lead.permasalahan, lead.alasanUmum).map(
                                                                        (alasanRinci, index) => {
                                                                        return (<MenuItem key={"alasanRinci" + index + lead._id} value={alasanRinci}>{alasanRinci}</MenuItem>);
                                                                        } 
                                                                    )
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                            {
                                                                lead.lastFuResultTmp === "Order" ? 
                                                                    (<TextField id="outlined-basic" label="Total Order" variant="outlined" style={{marginTop: 10}} value={lead.totalOrder} onChange={(event) => {this.props.handleTotalOrderChange(event, lead)}} />) : 
                                                                    (<></>)
                                                            }
                                                        </Box>
                                                    )
                                                }
                                                
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1} >
                                            <Grid item xs={6}>
                                                <strong>Hasil FU</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={lead.isEditing ? "left" : "right"} sx={{pr: "5px"}}>
                                                {
                                                    lead.isEditing && (
                                                        <Box>
                                                            <FormControl variant="outlined" style={{width: '100%'}} size='small'>
                                                                <InputLabel id="demo-simple-select-outlined-label">Hasil Follow Up</InputLabel>
                                                                <Select
                                                                    labelId="demo-simple-select-outlined-label"
                                                                    id="lastFuResult"
                                                                    value={lead.lastFuResultTmp === undefined | lead.lastFuResultTmp === null ? "" : lead.lastFuResultTmp}
                                                                    onChange={(event) => this.props.handleHasilFuChange(event, lead)}
                                                                    label="Hasil Follow Up"
                                                                >
                                                                    {
                                                                    Global.getListHasilFu().map(
                                                                        (cat) => {
                                                                        return (<MenuItem key={cat} value={cat}>{cat}</MenuItem>);
                                                                        } 
                                                                    )
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                            {
                                                                lead.lastFuResultTmp === "Order" ? 
                                                                    (<TextField id="outlined-basic" label="Total Order" variant="outlined" style={{marginTop: 10}} value={lead.totalOrder} onChange={(event) => {this.props.handleTotalOrderChange(event, lead)}} />) : 
                                                                    (<></>)
                                                            }
                                                        </Box>
                                                    )    
                                                }
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "5px", mb: "5px"}} />
                                        <Grid container spacing={1} sx={{mt: "10px"}}>
                                            <Grid item xs={6}>
                                                {
                                                    !lead.isEditing && (
                                                        <Button onClick={() => this.props.toggleStartEditFu(lead)} fullWidth variant='contained' color='secondary'>
                                                            Input FU
                                                        </Button>
                                                    )
                                                }

                                                {
                                                    lead.isEditing && (
                                                        <Button onClick={() => this.props.saveAnalisa(lead)} fullWidth variant='contained' color='error'>
                                                            Submit
                                                        </Button>
                                                    )
                                                }
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                                                {
                                                    !lead.isEditing && (
                                                        <Button fullWidth variant='contained' color='error'>Buka Chat</Button>
                                                    )
                                                }

                                                {
                                                    lead.isEditing && (
                                                        <Button onClick={() => this.props.toggleStartEditFu(lead)} fullWidth variant='contained' color='warning'>
                                                            Batal
                                                        </Button>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </AccordionDetails>
                            </Accordion>
                            // <Box elevation={2} sx={{mb: "10px", padding: "10px"}} key={`itemleads-${index}`}>
                            //     <Grid container spacing={1}>
                            //         <Grid item xs={12}>
                            //             <Typography component="span">{lead.fromName}</Typography>
                            //         </Grid>
                            //         <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                            //             {Global.maskPhoneNumber(lead.from)}
                            //         </Grid>
                            //         <Grid item xs={6} textAlign={"right"} sx={{pr: "5px"}}>
                            //             {Global.formatDateTimeToStrDateTime24(lead.created_at)}
                            //         </Grid>
                            //     </Grid>
                            //     <Divider />
                            // </Box>
                        );
                    })
                }
                </Box>
            </Box>
        );
    }
}
 
export default FollowUpRutinMobile;